<template>
  <kendo-window ref="kendoWindowRef" :title="'비밀번호 변경'" @open=onOpenWindow :modal="true" :width="'500px'" style="display:none;">
    <div>
      <ul class="filter_list">
        <li>
          <dl class="w100">
            <dt>현재 비밀번호</dt>
            <dd class="w100">
              <div class="f_r w30">
              </div>
              <span class="k-widget k-maskedtextbox w100">
                <span class="k-widget k-maskedtextbox" style="width: 100%;">
                  <kendo-maskedtextbox
                      name=""
                      :type="'password'"
                      v-model="userPwd"
                      maxlength="50"
                      placeholder="현재 비밀번호를 입력해 주세요."
                      class="w100"
                      autocomplete="off"
                      :style="'width: 100%;'"></kendo-maskedtextbox>
                  <span class="k-icon k-i-warning"></span>
                </span>
                <span class="k-icon k-i-warning"></span>
              </span>
            </dd>
          </dl>
        </li>
        <li class="w100">
          <dl class="w100">
            <dt>새 비밀번호 입력</dt>
            <dd class="w100">
              <span class="k-widget k-maskedtextbox w100">
                <span class="k-widget k-maskedtextbox w100" style="width: 100%;">
                  <kendo-maskedtextbox
                      name=""
                      :type="'password'"
                      v-model="newUserPwd"
                      maxlength="50"
                      placeholder="새 비밀번호를 입력해 주세요."
                      class="w100"
                      autocomplete="off"
                      :style="'width: 100%;'"></kendo-maskedtextbox>
                  <span class="k-icon k-i-warning"></span>
                </span>
                <span class="k-icon k-i-warning"> </span>
              </span>
              <div class="msg_area">
                <span v-show="isValid" class="msg_green">조건에 일치하는 비밀번호입니다.</span>
                <span v-show="!isValid" class="msg_red">조건에 일치하지 않는 비밀번호입니다.</span>
              </div>
            </dd>
          </dl>
        </li>
        <li class="w100">
          <dl class="w100">
            <dt>새 비밀번호 확인</dt>
            <dd class="w100">
              <span class="k-widget k-maskedtextbox w100">
                <span class="k-widget k-maskedtextbox w100" style="width: 100%;">
                  <kendo-maskedtextbox
                      name=""
                      :type="'password'"
                      v-model="newUserPwdConfirm"
                      maxlength="50"
                      placeholder="새 비밀번호를 한번 더 입력해 주세요."
                      class="w100"
                      autocomplete="off"
                      :style="'width: 100%;'"></kendo-maskedtextbox>
                  <span class="k-icon k-i-warning"></span>
                </span>
                <span class="k-icon k-i-warning"></span>
              </span>
              <div class="msg_area">
                <span v-show="isCorrect" class="msg_green">새 비밀번호와 일치합니다.</span>
                <span v-show="isCorrect === false" class="msg_red">새 비밀번호와 일치하지 않습니다.</span>
              </div>
            </dd>
          </dl>
        </li>
      </ul>
      <div class="info_txt">
        ※ 비밀번호는 영문, 숫자, 특수기호를 혼합한 8~50자리로 설정이 가능합니다.<br />
        ※ 기존에 사용하셨던 비밀번호는 사용하실 수 없습니다.
      </div>
      <div class="button_area w60 mgt30">
        <ul>
          <li class="w30">
            <button class="large_btn" @click="onCloseWindow">취소</button>
          </li>
          <li class="w30">
            <button class="large_btn orange ml5" @click="onClickSave">저장</button>
          </li>
        </ul>
      </div>
    </div>
  </kendo-window>
</template>

<script>
import ApiConfig from "@/api/api.config"
import ApiUtil from "@/api/api.util"
import EtnersPasswordUtil from '@/common/etners.password.util'
import EtnersEncDecUtil from '@/common/etners.encDec.util'
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: "CheckPwdWindow",
  watch: {
    'newUserPwd' : 'watchPwd',
    'newUserPwdConfirm' : 'watchPwd',
  },
  data () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),

      userPwd: null,
      newUserPwd: null,
      newUserPwdConfirm: null,
      isCorrect: null,
      isValid: null,
    }
  },
  // async mounted () {
  //   const vm = this
  //   // 공개키 요청
  //   const publicKey = await EtnersEncDecUtil.getRSA()
  //   vm.publicKey = publicKey
  // },
  methods: {
    watchPwd: function (){
      const vm = this
      const newUserPwd = vm.newUserPwd
      const newUserPwdConfirm = vm.newUserPwdConfirm

      // 비밀번호 조건 만족 -> isValid
      // 새 비밀번호 일치 -> isCorrect

      if(!EtnersPasswordUtil.spacePwd(newUserPwd) && !EtnersPasswordUtil.combinationPwd(newUserPwd)){
        vm.isValid = true
      }else{
        vm.isValid = false
      }
      if(vm.isValid && newUserPwdConfirm !== null) {
        if (newUserPwd === newUserPwdConfirm) {
          vm.isCorrect = true
        }else{
          vm.isCorrect = false
        }
      }
    },
    onClickSave: async function () {
      const vm = this
      const userPwd = vm.userPwd
      const newUserPwd = vm.newUserPwd
      const newUserPwdConfirm = vm.newUserPwdConfirm

      // check list
      // 1. 현재 비밀번호 입력 여부
      // 2. 지금 변경 === 'Y'
      //   1. 새 비밀번호 입력 여부
      //   1. 새 비밀번호 === 새 비밀번호 확인
      //   2. 새 비밀번호 : 영문, 숫자, 특수기호를 혼합한 8~50자리

      if (userPwd == undefined || !userPwd) {
        kendo.alert('현재 비밀번호를 입력해 주세요.')
        return
      }

      if (!newUserPwd || !newUserPwdConfirm) {
        kendo.alert('새 비밀번호를 입력해주세요.')
        return
      }

      const value = EtnersPasswordUtil.validation(newUserPwd, newUserPwdConfirm)
      if (!value) {
        return
      }

      // 평문을 RSA 공개키로 암호화
      const publicKey = vm.$store.state.encStoreModule.enc.data
      let userPwdRSA = await EtnersEncDecUtil.encryptRSA(userPwd, publicKey)
      let newUserPwdRSA = await EtnersEncDecUtil.encryptRSA(newUserPwd, publicKey)
      let newUserPwdConfirmRSA = await EtnersEncDecUtil.encryptRSA(newUserPwdConfirm, publicKey)

      // if(value) {
      const params = {
        loginUserToken: vm.loginUserToken,
        userPwd: userPwdRSA,
        newUserPwd: newUserPwdRSA,
      }

      kendo.confirm('비밀번호를 변경하시겠습니까?').done(function () {
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/user/updateUserPwdForMyPage.json`

        ApiUtil.post(url, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
            return false
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            kendo.alert(response.data.resultStatus.messageText)
            return false
          }

          kendo.alert('저장되었습니다.')
          vm.onCloseWindow()
        })
      })
      // }
    },

    onOpenWindow: function () {
      const vm = this

      // 초기화
      vm.userPwd = null
      vm.newUserPwd = null
      vm.newUserPwdConfirm = null
      vm.isCorrect = null
      vm.isValid = null
    },

    onCloseWindow: function () {
      const vm = this
      vm.$refs.kendoWindowRef.kendoWidget().close()
    },
  },
}
</script>

<style scoped>

</style>
